import { render } from "./SyaratKetentuan.vue?vue&type=template&id=085ab9b8"
import script from "./SyaratKetentuan.vue?vue&type=script&lang=js"
export * from "./SyaratKetentuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__